/**
 * Safely parse JSON
 * @param {string | undefined | null} jsonString
 * @param {any} fallbackValue
 * @returns {any}
 */
function parseJSON(jsonString, fallbackValue) {
  if (!jsonString) return fallbackValue;
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error("KitBuilder JSON Parse Error:", e, jsonString);
    return fallbackValue;
  }
}
